export default "__VITE_PUBLIC_ASSET__620f654e__"